<template>
  <div>
    <div class="box-transfer-value">
        <label class="label-transfer-value">Valor da Transferência (R$)*:</label>
        <input type="text" v-bind:value="getValue" v-on:input="setValue($event.target.value)"  name="input-transfer-value" class="form-control input-transfer-value" placeholder="0,00"  autofocus="autofocus">
        <button  type="button" name="button" class="btn-charge-minus" @click="alterValue(step * -1)">
          <i class="icon-minus"></i>
        </button>
        <button type="button" name="button" class="btn-charge-plus" @click="alterValue(step * 1)">
          <i class="icon-plus"></i>
        </button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.box-transfer-value {
    margin:                               105px 10px;
  }
.label-transfer-value {
    text-align:                           center;
    width:                                100%;
  }
.input-transfer-value {
  -webkit-border-radius:                0;
  background:                           transparent;
  border-radius:                        0;
  display:                              inline;
  font-weight:                          bold;
  font-size:                            1.4em;
  height:                               40px;
  margin:                               0 -5px 0 -1px;
  text-align:                           center;
  width:                                calc(100% - 82px);
}
.input-transfer-value-readonly {
  font-weight:                          bold;
  font-size:                            1.4em;
  height:                               40px;
  text-align:                           center;
}
.btn-charge-minus {
    -webkit-border-radius:                5px 0 0 5px;
    background:                           #CCC;
    border:                               2px solid #b5b5b5;
    border-radius:                        5px 0 0 5px;
    float:                                left;
    font-weight:                          bold;
    padding:                              10px;
    color:                                black;
    i {
      font-size:                          1.2em;
    }
  }
  .btn-charge-plus {
    -webkit-border-radius:                0 5px 5px 0;
    background:                           #CCC;
    border:                               2px solid #b5b5b5;
    border-radius:                        0 5px 5px 0;
    display:                              inline;
    font-weight:                          bold;
    padding:                              10px;
    color:                                black;
    i {
      font-size:                          1.2em;
    }
  }
</style>
<script>
import { centss } from "../../../filters/number";

export default {
  props: ['value', 'hideIncrement', 'step'],
  data() {
    return {
      currentValue: this.value
    };
  },
  computed: {
    getValue() {

      if (this.currentValue || this.currentValue == 0)
        return centss(this.currentValue);

      return "";
    }    
  },
  watch:{
      value(newValue){
        this.currentValue = newValue;
      }
  },
  methods: {
    alterValue(value){
      let newValue = this.currentValue + value;

      if(newValue < 0)return false;

      this.setValue('' + newValue);      
    },    

    setValue(newValue) {
      if (!Number.isNaN(newValue) && newValue != "") {
        this.currentValue = parseInt(newValue.replace(/[^0-9]/g, ""));
        this.$emit("input", this.currentValue);
      } else {
        this.currentValue = newValue;
        this.$emit("input", undefined);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// transfer-credit-value.vue?42f563ea